import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase';
import {
 createUserWithEmailAndPassword,
 signInWithEmailAndPassword,
 signOut,
 onAuthStateChanged,
 updateProfile,
} from 'firebase/auth';

const AuthContext = createContext();

export function useAuth() {
 return useContext(AuthContext);
}

export function AuthProvider({ children }) {
 const [user, setUser] = useState(null);
 const [loading, setLoading] = useState(true);

 function signup(email, password, displayName) {
  return createUserWithEmailAndPassword(auth, email, password).then(
   (cred) => updateProfile(cred.user, { displayName }).then(() => cred)
  );
 }

 function login(email, password) {
  return signInWithEmailAndPassword(auth, email, password);
 }

 function logout() {
  return signOut(auth);
 }

 useEffect(() => {
  const unsub = onAuthStateChanged(auth, (u) => {
   setUser(u);
   setLoading(false);
  });
  return unsub;
 }, []);

 const value = { user, signup, login, logout, loading };

 return (
  <AuthContext.Provider value={value}> {!loading && children}
  </AuthContext.Provider> );
}
